import { render, staticRenderFns } from "./media-list.vue?vue&type=template&id=5116c0ab&"
import script from "./media-list.vue?vue&type=script&lang=js&"
export * from "./media-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports